import { render, staticRenderFns } from "./ServicesIndex.vue?vue&type=template&id=c42923ce&"
import script from "./ServicesIndex.vue?vue&type=script&lang=js&"
export * from "./ServicesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports